import * as React from "react";

import { ICouncil } from "src/interfaces";
import RoadSignTrace from "./RoadSignTrace";

interface IProps {
  councils: ICouncil[];
  year: string;
}

class RoadSign extends React.PureComponent<IProps, {}> {
  public render() {
    return (

      <div className="road-sign">
        <div className="road-sign__image">
          <div className="road-sign__board">
            <div className="road-sign__content font-bold">
              {this.props.councils.map((council, index) => (
                <RoadSignTrace 
                  council={council} 
                  key={index} 
                  ordinal={index + 1} 
                  year={this.props.year} />
              ))}
            </div>
          </div>
          <div className="flex flex-wrap">
            <div className="w-1/2 text-center">
              <div className="road-sign__post mr-10" />
            </div>
            <div className="w-1/2 text-center">
              <div className="road-sign__post ml-10" />
            </div>
          </div>
        </div>
      </div>
      
    );
  }
}

export default RoadSign;



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/Roads/RoadSign.tsx